import { useEffect } from "react";
import { useSearchParams, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { FaExternalLinkAlt } from "react-icons/fa";

const PublicLinkRedirect = () => {
  const [searchParams] = useSearchParams();
  const { companyUsername } = useParams();

  useEffect(() => {
    const destinationUrl = searchParams.get("to");

    if (destinationUrl && companyUsername) {
      // Track referral click using correct endpoint
      fetch(
        `https://zola.technology/api/company/${companyUsername}/referral/increment-clicks/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (!res.ok) {
            console.warn("Click tracking failed");
          }
        })
        .catch((err) => {
          console.error("Tracking error:", err);
        });

      // Redirect after delay (adjust if 40s is too long)
      setTimeout(() => {
        window.location.href = decodeURIComponent(destinationUrl);
      }, 300);
    }
  }, [searchParams, companyUsername]);

  return (
    <div className="w-full h-screen flex flex-col items-center justify-center bg-white dark:bg-gray-900">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{
          repeat: Infinity,
          duration: 2,
          ease: "linear",
        }}
        className="text-blue-500 text-5xl mb-4"
      >
        <FaExternalLinkAlt />
      </motion.div>

      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-lg text-gray-600 dark:text-gray-300"
      >
        Redirecting you to the external site...
      </motion.p>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1 }}
        className="text-sm text-gray-400 dark:text-gray-500 mt-2"
      >
        Please wait, this should only take a few seconds
      </motion.p>
    </div>
  );
};

export default PublicLinkRedirect;
